export enum BillOfMaterialsType {
  VITESCO,
  SCHAEFFLER,
}
